<template>

	<TransitionRoot appear :show="isOpen" as="template">
    <Dialog  :initialFocus="initFocusedRef" as="div" class="relative z-[100]">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/90 z-[100]" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto z-[100]">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out absolute "
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100 "
            leave="duration-200 ease-in absolute"
            leave-from="opacity-100 scale-100 "
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel 
              class="md:h-[200px] md:w-[389px] sm:h-[100px] h-auto w-auto  max-w-md transform rounded-2xl bg-white p-6 text-center align-middle shadow-xl text-xl transition-all flex flex-col justify-center items-center"
            ref="loaderContentRef">

              {{ t('shared.Loading') }}

            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { ref } from 'vue'
import { useI18n } from "vue-i18n";
import {
	TransitionRoot,
	TransitionChild,
	Dialog,
	DialogOverlay,
	DialogTitle,
  DialogPanel
} from '@headlessui/vue'

export default {
	name: 'default-modal',
	components: {
		TransitionRoot,
		TransitionChild,
		Dialog,
		DialogOverlay,
		DialogTitle,
    DialogPanel,
},
	props: ['modalIsOpen','isOverlayBgBlack','widthSM', 'initFocusedRef'],
	computed: {
		isOpen: function () {
			return this.modalIsOpen
		},
	},
  setup() {
      const { t } = useI18n();

      return {
        t
      }
    }
}
</script>
